import React from 'react';
import { useNavigate } from 'react-router-dom';
import { loadTenantAsset } from '../redux/tenantSlice';
import { useSelector } from "react-redux";
import { useTranslation } from 'react-i18next';

// import logo from '../assets/images/logo.png';
import styles from '../styles/components/reclamation.module.scss';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faAngleLeft } from '@fortawesome/free-solid-svg-icons';
import classNames from 'classnames';
import { LanguageSwitcher, NewLanguageSwitcherLanding } from './LanguageSwitcher';

const Header = ({ isSticky, currentLang, setCurrentLang }) => {
  const tenantState = useSelector((state) => state.tenant);
  const { t, i18n } = useTranslation();
  // const logo = tenantState?.tenant.assets?.logo;
  const navigate = useNavigate();
  const tenantName = useSelector((state) => state.tenant?.tenant.name) || '';
  const logo =
    loadTenantAsset(tenantName, i18n.language === 'ar' ? 'logo_fr' : 'logo_ar') ||
    loadTenantAsset(tenantName, 'logo');

  const goBack = () => {
    navigate('/', { replace: false, state: { preventReload: true } });
  };

  return (
    <div className={classNames(styles.head, { [styles.sticky]: isSticky })}>
      <div className={classNames(styles.backArrowContainer, { [styles.sticky]: isSticky })}>
        <button
          style={{    border: 'none',
          background: 'transparent',
          width: 'fit-content'}}
          type='button' id="backButton" onClick={goBack}>
          <FontAwesomeIcon className={styles.back} icon={faAngleLeft}/>
        </button>
        <img
          className={styles.logoHeader}
          src={logo}
          alt={"Default Logo"}
          loading="eager"
          decoding="async"
        />
       { /* <LanguageSwitcher currentLang={currentLang} setCurrentLang={setCurrentLang} /> */ }
       <NewLanguageSwitcherLanding currentLang={currentLang} setCurrentLang={setCurrentLang} /> 
      </div>
    </div>
  );
};

export default Header;
